import { useFormik } from "formik";
import * as Yup from "yup";

const useResetPasswordForm = (handleSubmit) => {
  return useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Էլ․ Հասցեի անվավեր ձևաչափ")
        .required("Պարտադիր դաշտ (Էլ․ Հասցե)"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
};

export default useResetPasswordForm;
